import { UnknownOutputParams } from 'expo-router';
import {
  ADVANCE_HEADER,
  BRAND_HEADER,
  CHECKING_HEADER,
  Header,
  MULTI_STEP_INCENTIVE_HEADER,
  ORGANIC_HEADER,
  REFERRAL,
  SAVING_HEADER,
} from 'features/signup/constants';
import { getParam } from 'features/signup/utils/signupUtils';
import { useCallback, useEffect, useState } from 'react';
import {
  campaign as campaignParams,
  REFERRAL_QUERY_PARAM,
  V2A_INCENTIVE_REFERRAL_SOURCE,
} from 'shared/constants/urlParams';

const useAttributions = (
  urlSearchParams: UnknownOutputParams,
  isValidReferral: boolean,
) => {
  const [headerText, setHeaderText] = useState('');
  const [subHeadText, setSubHeadText] = useState('');
  const [headerHero, setHeaderHero] = useState('');
  const [headerTextColor, setHeaderTextColor] = useState('');
  const [headerBackgroundColor, setHeaderBGColor] = useState('');
  const [formHeaderText, setFormHeaderText] = useState('');
  const [headerSubHeadTextColor, setHeaderSubHeadTextColor] = useState('');
  const [headerImage, setHeaderImage] = useState('');

  const setHeaderAttributes = (header: Header) => {
    setHeaderText(header.HEADER_TEXT);
    setSubHeadText(header.SUBHEAD_TEXT);
    setHeaderHero(header.HEADER_HERO);
    setHeaderTextColor(header.HEADER_TEXT_COLOR);
    setHeaderBGColor(header.HEADER_BG_COLOR);
    setFormHeaderText(header.FORM_HEADER);
    setHeaderSubHeadTextColor(header.HEADER_SUBHEAD_TEXT_COLOR);
    setHeaderImage(header.HEADER_IMAGE);
  };

  const handleStatsHeader = useCallback((utmContent: string) => {
    switch (utmContent) {
      case 'apply-varo':
        setHeaderAttributes(BRAND_HEADER);
        break;
      case 'apply-bank-account':
        setHeaderAttributes(CHECKING_HEADER);
        break;
      case 'apply-savings-account':
        setHeaderAttributes(SAVING_HEADER);
        break;
      case 'apply-credit-builder':
        setHeaderAttributes(BRAND_HEADER);
        break;
      case 'apply-cash-advance':
      case 'apply-cash-advance-250':
      case 'apply-cash-advance-500':
        setHeaderAttributes(ADVANCE_HEADER);
        break;
      default:
        setHeaderAttributes(ORGANIC_HEADER);
        break;
    }
  }, []);

  useEffect(() => {
    const utmContent = isValidReferral
      ? getParam(urlSearchParams, REFERRAL_QUERY_PARAM)
      : (getParam(urlSearchParams, campaignParams.content) as string);
    const utmSource = isValidReferral
      ? REFERRAL
      : getParam(urlSearchParams, campaignParams.source);
    const isIncentiveCampaign = utmSource === V2A_INCENTIVE_REFERRAL_SOURCE;

    if (isIncentiveCampaign) {
      setHeaderAttributes(MULTI_STEP_INCENTIVE_HEADER);
    } else {
      handleStatsHeader(utmContent as string);
    }
  }, [urlSearchParams, isValidReferral, handleStatsHeader]);

  return {
    headerText,
    subHeadText,
    headerHero,
    headerTextColor,
    headerBackgroundColor,
    headerSubHeadTextColor,
    formHeaderText,
    headerImage,
  };
};

export default useAttributions;
